let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("42qE5")).then(() => parcelRequire('4leZi'));